<template>
    <div>
        <div class="pages"
            :style="titleform.itemLogo ? `
                        background: url(${titleform.itemLogo}); 
                        background-repeat: no-repeat; 
                        background-position: center; 
                        background-size: cover;` : 'background: radial-gradient(72.67% 37.85% at 11.666666666666666% 42.1875%, rgba(199, 218, 255, 1) 0%, rgba(242, 245, 255, 1) 100%)'">
            <!-- <img v-if="titleform.itemLogo" class="bg" :src="titleform.itemLogo" alt="" srcset=""> -->
            <div class="first" v-if="titleform.templateType < 4">
                <div class="title-box">
                    <div class="title" :style="`color:${titleform.fontColor}`">{{ titleform.itemTitle }}</div>
                    <div class="subtitle" :style="`color:${titleform.fontColor}`">{{ titleform.itemSubtitle }}</div>
                </div>

                <div class="add-box">
                    <img :src="titleform.shopLogo" alt="">
                    <div class="font-text">
                        <div class="font-text-1">{{ titleform.shopName }}</div>
                        <div class="font-text-2">{{ titleform.shopNotice }}</div>
                    </div>
                </div>

                <!-- 模板一 -->
                <div class="app-box-type-1" v-if="titleform.templateType == 1">
                    <div class="app-list">
                        <div class="app-item" v-for="item, index in appList" :key="index"
                            @click.stop="handleClick(item)">
                            <!-- ../assets/img/common/xhs.png -->
                            <img class="app-item-img" :src="item.itemLogo" alt="">
                            <div class="app-item-text1">{{ item.itemTitle }}</div>
                            <div class="app-item-text2">{{ item.itemSubtitle }}</div>
                        </div>
                    </div>
                    <div class="goods-list" v-if="goodsList.length > 0">
                        <div class="goods-list-title" :style="{ color: goodsTitleColor }">{{ goodsTitle }}</div>
                        <div class="goods-list-item" v-for="item, index in goodsList" :key="index">
                            <img class="goods-img" :src="item.itemLogo" alt="" srcset="">
                            <div class="goods-info">
                                <div class="goods-info-title">{{ item.itemTitle }}</div>
                                <div class="goods-info-subtitle">{{ item.itemSubtitle }}</div>
                                <div class="goods-info-price">
                                    <div class="goods-price1">￥{{ item.goodsPrice }}</div>
                                    <div class="goods-price2">￥{{ item.goodsMarketPrice }}</div>
                                    <div class="goods-btn" @click="goodsClick(item)">抢购</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <!-- 模板二 -->
                <div class="app-box-type-2" v-else-if="titleform.templateType == 2">
                    <div class="app-list">
                        <div class="app-item" v-for="item, index in appList" :key="index"
                            @click.stop="handleClick(item)">
                            <img :src="item.itemLogo" alt="" />
                            <div>
                                <div class="app-item-text1">{{ item.itemTitle }}</div>
                                <div class="app-item-text2">{{ item.itemSubtitle }}</div>
                            </div>
                        </div>
                    </div>
                    <div class="goods-list" v-if="goodsList.length > 0">
                        <div class="goods-list-title" :style="{ color: goodsTitleColor }">{{ goodsTitle }}</div>
                        <div class="goods-list-item" v-for="item, index in goodsList" :key="index">
                            <img class="goods-img" :src="item.itemLogo" alt="" srcset="">
                            <div class="goods-info">
                                <div class="goods-info-title">{{ item.itemTitle }}</div>
                                <div class="goods-info-subtitle">{{ item.itemSubtitle }}</div>
                                <div class="goods-info-price">
                                    <div class="goods-price1">￥{{ item.goodsPrice }}</div>
                                    <div class="goods-price2">￥{{ item.goodsMarketPrice }}</div>
                                    <div class="goods-btn" @click="goodsClick(item)">抢购</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <!-- 模板三 -->
                <div class="app-box-type-3" v-else-if="titleform.templateType == 3">
                    <div v-for="item, index in modelList" :key="index">
                        <div class="app-list" v-if="item.children.length > 0 && item.itemType != 200000">
                            <div class="app-title" :style="{ color: item.fontColor }">{{ item.itemTitle }}
                            </div>
                            <div style="display: flex;flex-wrap: wrap;">
                                <div class="app-item" v-for="(app, index2) in item.children" :key="index2"
                                    @click="handleClick(app)">
                                    <img class="app-item-img" :src="app.itemLogo" alt="">
                                    <div class="app-item-text">{{ app.itemTitle }}</div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="goods-list" v-if="goodsList.length > 0">
                        <div class="goods-list-title" :style="{ color: goodsTitleColor }">{{ goodsTitle }}</div>
                        <div class="goods-list-item" v-for="item, index in goodsList" :key="index">
                            <img class="goods-img" :src="item.itemLogo" alt="" srcset="">
                            <div class="goods-info">
                                <div class="goods-info-title">{{ item.itemTitle }}
                                </div>
                                <div class="goods-info-subtitle">{{ item.itemSubtitle }}</div>
                                <div class="goods-info-price">
                                    <div class="goods-price1">￥{{ item.goodsPrice }}</div>
                                    <div class="goods-price2">￥{{ item.goodsMarketPrice }}</div>
                                    <div class="goods-btn" @click="goodsClick(item)">抢购</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <!-- 模板4 -->
            <div class="model4" v-if="titleform.templateType == 4">
                <div class="model4-title">
                    <div class="title" :style="`color:${titleform.fontColor}`">
                        {{ titleform.itemTitle }}
                    </div>
                    <div class="subtitle" :style="`color:${titleform.fontColor}`">
                        {{ titleform.itemSubtitle }}
                    </div>
                    <div class="shop">
                        <img class="shop-img" :src="titleform.shopLogo" alt="" />
                        <div class="shop-text">{{ titleform.shopName }}</div>
                    </div>
                </div>

                <div class="app-box-type-4">
                    <div v-for="item, index in modelList" :key="index">
                        <div class="app-list" v-if="item.children.length > 0 && item.itemType != 200000">
                            <div class="app-title" :style="{ color: item.fontColor }">{{ item.itemTitle }}
                            </div>
                            <div style="display: flex;flex-wrap: wrap;">
                                <div class="app-item" v-for="(app, index2) in item.children" :key="index2"
                                    @click="handleClick(app)">
                                    <img class="app-item-img" :src="app.itemLogo" alt="">
                                    <div class="app-item-text">{{ app.itemTitle }}</div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="goods-list" v-if="goodsList.length > 0">
                        <div class="goods-list-title" :style="{ color: goodsTitleColor }">{{ goodsTitle }}</div>
                        <div class="goods-list-item" v-for="item, index in goodsList" :key="index">
                            <img class="goods-img" :src="item.itemLogo" alt="" srcset="">
                            <div class="goods-info">
                                <div class="goods-info-title">{{ item.itemTitle }}
                                </div>
                                <div class="goods-info-subtitle">{{ item.itemSubtitle }}</div>
                                <div class="goods-info-price">
                                    <div class="goods-price1">￥{{ item.goodsPrice }}</div>
                                    <div class="goods-price2">￥{{ item.goodsMarketPrice }}</div>
                                    <div class="goods-btn" @click="goodsClick(item)">抢购</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <!-- 模板5 -->
            <div class="model5" v-if="titleform.templateType == 5">
                <div class="model5-title"
                    :style="`background: url(${titleImgList[0].url}) no-repeat; background-size: cover;`">
                    <div class="title" :style="`color:${titleform.fontColor}`">
                        {{ titleform.itemTitle }}
                    </div>
                    <div class="shop">
                        <img class="shop-img" :src="titleform.shopLogo" alt="" />
                        <div class="shop-text" :style="`color:${titleform.fontColor}`">{{ titleform.shopName }}</div>
                    </div>
                </div>

                <div class="app-box-type-5">
                    <div class="four-img">
                        <div class="four-img-box" v-for="img, index in fourImgList" :key="index">
                            <div class="four-img-box-item" v-if="!img.url">
                            </div>
                            <img v-else class="four-img-box-img" :src="img.url" alt="" @click="clickImg(img)">
                        </div>
                    </div>

                    <div v-for="item, index in modelList" :key="index">
                        <div class="app-list" v-if="item.children.length > 0 && item.itemType != 200000">
                            <div class="app-title" :style="{ color: item.fontColor }">{{ item.itemTitle }}
                            </div>
                            <div style="display: flex;flex-wrap: wrap;">
                                <div class="app-item" v-for="(app, index2) in item.children" :key="index2"
                                    @click="handleClick(app)">
                                    <img class="app-item-img" :src="app.itemLogo" alt="">
                                    <div class="app-item-text">{{ app.itemTitle }}</div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="three-img">
                        <div class="three-img-top">
                            <img class="three-img-top-img" v-if="threeImgList[0].url" :src="threeImgList[0].url" alt=""
                                @click="clickImg(threeImgList[0])">
                            <div class="three-img-top-box" v-else>
                            </div>
                        </div>
                        <div class="three-img-bottom">
                            <div class="i-box">
                                <div class="i-box-item">
                                    <img class="i-box-item-img" v-if="threeImgList[1].url" :src="threeImgList[1].url"
                                        alt="" @click="clickImg(threeImgList[1])">
                                    <div class="i-box-item-empty" v-else>
                                    </div>
                                </div>
                                <div class="i-box-item">
                                    <img class="i-box-item-img" v-if="threeImgList[2].url" :src="threeImgList[2].url"
                                        alt="" @click="clickImg(threeImgList[2])">
                                    <div class="i-box-item-empty" v-else>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="goods-list" v-if="goodsList.length > 0">
                        <div class="goods-list-title" :style="{ color: goodsTitleColor }">{{ goodsTitle }}</div>
                        <div class="goods-list-item" v-for="item, index in goodsList" :key="index">
                            <img class="goods-img" :src="item.itemLogo" alt="" srcset="">
                            <div class="goods-info">
                                <div class="goods-info-title">{{ item.itemTitle }}
                                </div>
                                <div class="goods-info-subtitle">{{ item.itemSubtitle }}</div>
                                <div class="goods-info-price">
                                    <div class="goods-price1">￥{{ item.goodsPrice }}</div>
                                    <div class="goods-price2">￥{{ item.goodsMarketPrice }}</div>
                                    <div class="goods-btn" @click="goodsClick(item)">抢购</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- 添加遮罩层 -->
        <div v-if="isCreate" class="loading-mask">
            <div class="loading-content">
                <div class="loading-spinner"></div>
                <p>文案生成中，请稍候...</p>
            </div>
        </div>

        <!-- 遮罩 -->
        <div class="mask" v-if="maskShow">
            <!-- 显示图片 -->
            <div class="img-box">
                <img :src="wxImage" alt="">
            </div>

            <!-- 关闭按钮 -->
            <div class="btn-close" @click="maskShow = false">关闭</div>
            <div class="btn-save" @click="saveImage()">保存图片</div>
        </div>

        <div class="mask" v-if="isShowDZdaka">
            <div class="dzdaka-box">
                <div class="dzdaka-header">
                    <h3>大众点评打卡</h3>
                    <div class="close-btn" @click="isShowDZdaka = false">×</div>
                </div>
                <div>
                    <img class="dzdaka-img" src="../assets/img/pyp/daka.jpg" alt="">
                </div>
                <div class="btn-box">
                    <button class="btn" @click="DZdaka()">去打卡</button>
                    <button class="btn" @click="DZdaka_comment()">去点评</button>
                </div>
            </div>
        </div>

        <div class="mask" v-if="isShowPyq">
            <div class="pyq-content" v-if="!isSetText">
                <div class="pyq-section">
                    <div style="display: flex; justify-content: space-between;align-items: center;">
                        <div class="section-title">
                            <span>资源文案</span>
                            <!-- <span v-if="app.isEnableAi == 1" class="set-text" @click="isSetText = true">设置</span> -->
                        </div>
                        <div class="copy-btn" @click="copyText()">一键复制</div>
                    </div>
                    <div class="text-content">
                        {{ chatAiContentAgent }}
                    </div>
                </div>

                <div class="refush-btn" @click="isSetText = true" v-if="app.isEnableAi == 1">
                    <img :class="{ 'rotate': isCreate }" src="../assets/img/common/refush2.png" alt="">
                    重新生成文案
                </div>

                <div class="pyq-section" v-if="app.itemType != 140040 && app.itemType != 140030">
                    <div style="display: flex; justify-content: space-between;align-items: center;">
                        <div class="section-title">资源图片</div>
                        <div class="copy-btn" @click="downLoadAll()">一键保存</div>
                    </div>
                    <div class="image-grid">
                        <div class="image-item" v-for="(item, index) in imageList" :key="index">
                            <img :src="item" alt="资源图片" />
                        </div>
                    </div>
                </div>
                <div class="pyq-section" v-else>
                    <div style="display: flex; justify-content: space-between;align-items: center;">
                        <div class="section-title">资源视频</div>
                        <div class="copy-btn" @click="downLoadVideo()">一键保存</div>
                    </div>
                    <div class="video-box">
                        <video class="video" :src="videoUrl" controls></video>
                    </div>
                </div>

                <div class="pyq-actions">
                    <button class="btn-secondary" @click="isShowPyq = false">取消</button>

                    <div class="btn-a"
                        v-if="app.itemType == 150020 || app.itemType == 150030 || app.itemType == 150050 || app.itemType == 150060 || app.itemType == 150070 || app.itemType == 160030">
                        <a :href="outAppUrl">{{ app.itemType == 160030 ? '去发布' : '点评+收藏' }}</a>
                    </div>
                    <button class="btn-primary" @click="comment()" v-else>{{ app.itemType == 160010 || app.itemType ==
                        160020 || app.itemType == 140030 || app.itemType ==
                        140040 ? '去发布' : '点评+收藏' }}</button>
                    <button class="btn-primary2" @click="comment2()" v-if="app.itemType == 160020 || app.itemType ==
                        140030">复制文案发布</button>
                </div>
            </div>

            <div class="pyq-content" v-if="isSetText">
                <div>
                    <div class="mune-set-back" @click="isSetText = false">
                        <i class="el-icon-arrow-left" style="color: #e6a23c;"></i>
                        <span style="color: #e6a23c;">返回</span>
                    </div>

                    <div>
                        <div class="menu-set-title">推荐菜/套餐</div>
                        <div class="tag-container">
                            <el-tag v-for="tag in tagList" :key="tag.label" :type="tag.type"
                                :disable-transitions="false" @click="addMenu(tag)">
                                {{ tag.label }}
                            </el-tag>
                        </div>

                        <div class="menu-set-title">宣传点</div>
                        <div>
                            <el-tag v-for="tag in featureList" :key="tag.label" :type="tag.type"
                                :disable-transitions="false" @click="setFeature(tag)">
                                {{ tag.label }}
                            </el-tag>
                        </div>

                        <div class="menu-set-title">选择笔记类型</div>
                        <div>
                            <el-tag v-for="tag in themeList" :key="tag.label" :type="tag.type"
                                :disable-transitions="false" @click="setTheme(tag)">
                                {{ tag.label }}
                            </el-tag>
                        </div>

                        <div class="menu-set-title">其他要求</div>
                        <div>
                            <el-input type="textarea" :rows="2" placeholder="请输入内容"
                                v-model="app.chatAiContentRequirement">
                            </el-input>
                        </div>

                        <div class="menu-set-btn" @click="setConfirm()">确定</div>
                    </div>
                </div>
            </div>
        </div>
        <div class="mask" v-if="isShowSPH">
            <div class="popup-container">
                <div class="popup-content">
                    <div class="popup-header">
                        <h3>跳转提示</h3>
                    </div>
                    <div class="popup-body">
                        <p>即将跳转到小程序，是否继续？</p>
                    </div>
                    <div class="popup-footer">
                        <button class="btn-cancel" @click="closePopup">取消</button>
                        <a class="btn-confirm" :href="outAppUrl">确定</a>
                    </div>
                </div>
            </div>
        </div>

        <div class="maskTips" v-if="isShowTips">
            <div style="display: flex;justify-content: end;">
                <img src="../assets/img/pyp/share.png" alt="">
            </div>
        </div>
    </div>
</template>

<script>
import {
    findPpCardItemType,
    findPpCardNfc,
    openSahreLinkForNfc,
    publishDyVideoForNfc,
    publishKsVideoForNfc,
    publishXhsVideoForNfc,
    publishWxOrZfbForNfc,
    publishXhsImagesForNfc,
    publishCtripImagesForNfc,
    openLinkWxWifiForNfc,
    publishWxPyqForNfc,
    findPpCardWorkVideo,
    getShopInfo,
    apiCreateAiTextForUser,
    singleDrawWork,
    findPpCardWorkDetail
} from "@/api/index.js";
import '../utils/pyp/xhs-1.0.1';
import axios from "axios";
import { asyncDispose } from "core-js/library/es6/symbol";

export default {
    components: {},
    props: [],
    data() {
        return {
            shopId: '',

            titleform: {},
            modelList: [],
            model3List: [],
            appList: [],
            appList3: [],

            shopForm: {},
            goodsList: [],
            goodsTitle: '',
            goodsTitleColor: '#000000',

            maskShow: false,
            wxImage: '',

            imageList: [],
            isShowPyq: false,
            chatAiContentAgent: '',
            videoUrl: '',

            isShowDZdaka: false,

            app: {},//当前模块
            isShowTips: false,// 提示用默认浏览器打开

            isCreate: false,
            DSQ: null,

            outAppUrl: '',

            isShowSPH: false,
            isSetText: false,

            tagList: [],
            featureList: [
                {
                    label: '环境漂亮',
                    type: ''
                },
                {
                    label: '口味地道',
                    type: ''
                },
                {
                    label: '服务热情',
                    type: ''
                }
            ],
            themeList: [
                {
                    label: '娱乐风格',
                    type: 'info'
                },
                {
                    label: '新闻风格',
                    type: 'info'
                },
                {
                    label: '中式风格',
                    type: 'info'
                },
                {
                    label: '市井风',
                    type: 'info'
                },
                {
                    label: '轻奢风',
                    type: 'info'
                },
                {
                    label: '美式风格',
                    type: 'info'
                },
                {
                    label: '探店风格',
                    type: 'warning'
                }
            ],

            aiSetTheme: {
                goods: '',
                theme: '',
                require: '',
            },

            titleImgList: [],
            fourImgList: [],
            threeImgList: [],

            xhsData: null,
        };
    },
    watch: {
        'app.chatAihotSelling': {
            handler(newVal) {
                console.log('###', newVal);
                let temp = [];
                if (typeof newVal === 'string' && newVal) {
                    temp = newVal.split(',');
                } else if (Array.isArray(newVal)) {
                    // 如果 newVal 已经是数组，则直接使用
                    temp = newVal;
                }

                temp.forEach(item => {
                    this.tagList.push({
                        label: item,
                        type: 'info'
                    });
                });

                if (this.tagList.length > 0) {
                    this.tagList[0].type = 'success';
                }
            },
            // deep: true
        },
        isShowPyq: {
            handler(newVal) {
                if (newVal) {
                    this.aiSetTheme = {
                        goods: '',
                        theme: '',
                        require: '',
                    }
                }
            },
        }
    },
    created(e) {
        this.shopId = this.getHashParams('shopId');
    },
    async mounted() {
        await this.getModelList();

        // await this.getModel3List();

        // 修改网页标题
        document.title = '碰一碰';
    },
    methods: {
        isWechatBrowser() {
            const ua = navigator.userAgent.toLowerCase();
            return ua.includes('micromessenger');
        },
        // 获取参数
        getHashParams() {
            const hash = window.location.href; // 当前页面完整 URL
            const queryString = hash.split('?')[1] || ''; // 提取 ? 后面的查询字符串
            const params = new URLSearchParams(queryString); // 创建 URLSearchParams 对象以解析查询字符串
            const result = {};

            for (const [key, value] of params.entries()) {
                result[key] = value; // 将参数存入对象
            }

            return result.shopId; // 返回解析后的对象
        },

        async getModelList() {
            try {
                const res = await findPpCardNfc({ shopId: this.shopId, pageSize: 9999 });
                if (res.code == 1) {
                    this.titleform = res.data.list[0] || [];
                    this.modelList = res.data.list[0].children || [];

                    if (this.titleform.templateType == 5) {
                        if (res.data.list[0].cateringPosterTemp) {
                            this.titleform.cateringPosterTemp = JSON.parse(res.data.list[0].cateringPosterTemp);
                            console.log(this.titleform.cateringPosterTemp);
                        }

                        this.titleImgList = this.titleform.cateringPosterTemp.titleImgList;
                        this.fourImgList = this.titleform.cateringPosterTemp.fourImgList;
                        this.threeImgList = this.titleform.cateringPosterTemp.threeImgList;
                    }

                    this.appList = [];
                    this.goodsList = [];
                    this.modelList.forEach(item => {
                        if (item.itemType == 200000) {
                            this.goodsTitle = item.itemTitle
                            this.goodsTitleColor = item.fontColor
                        }

                        item.children.forEach(child => {
                            if (child.itemType != 200010) {
                                this.appList.push(child);
                            } else {
                                this.goodsList.push(child);
                            }
                        })
                    })
                } else {
                    this.$message.error(res.msg);
                }
            } catch (error) {
                this.$message.error(error);
            }
        },

        goodsClick(goods) {
            if (goods.platform == 1) {
                window.location.href = 'snssdk1128://poi/goodsdetail/?activity_id=' + goods.outUrl;
            } else {
                const newWindow = window.open('', '_blank');
                if (newWindow) {
                    newWindow.location = goods.outUrl;
                } else {
                    // 如果弹窗被阻止，提供备用方案
                    window.location.href = goods.outUrl;
                }
            }
        },


        async reCreateText() {
            // 判断是否已经设置过文案要求
            let isSet = false;
            if (this.aiSetTheme.goods != '') {
                isSet = true;
            }

            if (this.isCreate) {
                this.$message.error('请等待生成文案');
                return;
            }
            try {
                const httpData = {
                    ppCardItemId: this.app.ppCardItemId,
                    shopName: this.app.shopName,
                    shopAddress: this.app.shopAddress,
                    chatAiContentMaxSize: this.app.chatAiContentMaxSize,
                    chatAicopywritingTheme: isSet ? this.aiSetTheme.theme : this.app.chatAicopywritingTheme,
                    chatAihotSelling: isSet ? this.aiSetTheme.goods : this.app.chatAihotSelling,
                    chatAiContentRequirement: isSet ? `${this.app.chatAiContentRequirement},${this.aiSetTheme.require}` : this.app.chatAiContentRequirement,
                    aiType: this.app.aiType,
                    llmModelDrawStyleId: 17642,
                }
                const res = await apiCreateAiTextForUser(httpData);
                if (res.code == 1) {
                    await this.searchResult(res.data.drawWorkId);
                } else {
                    this.$message.error(res.msg);
                }
            } catch (error) {
                window.alert(error);
            }
        },

        async createAIText() {
        },

        // 轮询结果
        async searchResult(id) {
            return new Promise((resolve, reject) => {
                this.isCreate = true;
                this.DSQ = setInterval(async () => {
                    try {
                        const res = await findPpCardWorkDetail({ drawWorkId: id })
                        if (res.data.workResultStatus == 200 || res.data.workResultStatus == 300) {
                            this.DSQ && clearInterval(this.DSQ);
                            this.chatAiContentAgent = res.data.workText;

                            this.isCreate = false;
                            resolve(); // 完成时resolve promise
                        } else if (res.data.workResultStatus == 199) {
                            this.DSQ && clearInterval(this.DSQ);
                            this.$message.error(res.data.workResultMsg);

                            this.isCreate = false;
                            reject(new Error(res.data.workResultMsg)); // 出错时reject promise
                        }
                    } catch (error) {
                        this.isCreate = false;
                        this.DSQ && clearInterval(this.DSQ);
                        this.$message.error(error);
                        reject(error); // 出错时reject promise
                    }
                }, 5000)
            });
        },

        // 复制文本到剪贴板
        copyText() {
            if (!this.chatAiContentAgent) {
                window.alert('没有可复制的文案')
                return;
            }

            // 使用现代 Clipboard API (如果支持)
            if (navigator.clipboard && window.isSecureContext) {
                navigator.clipboard.writeText(this.chatAiContentAgent).then(() => {
                    alert('文案已复制到剪贴板');
                }).catch(err => {
                    console.error('复制失败:', err);
                    // 降级到传统方法
                    this.fallbackCopyText();
                });
            } else {
                // 降级到传统方法
                this.fallbackCopyText();
            }
        },

        // 传统复制方法 (兼容旧浏览器)
        fallbackCopyText() {
            const textArea = document.createElement("textarea");
            textArea.value = this.chatAiContentAgent;

            // 避免滚动到底部
            textArea.style.top = "0";
            textArea.style.left = "0";
            textArea.style.position = "fixed";
            textArea.style.opacity = "0";

            document.body.appendChild(textArea);
            textArea.focus();
            textArea.select();

            try {
                const successful = document.execCommand('copy');
                if (successful) {
                    alert('文案已复制到剪贴板');
                } else {
                    console.error('复制失败');
                }
            } catch (err) {
                console.error('复制失败:', err);
            }

            document.body.removeChild(textArea);
        },

        async downLoadVideo() {
            if (!this.videoUrl) {
                this.$message.warning('没有可下载的视频');
                return;
            }

            const link = this.videoUrl;
            const fileName = link.substring(link.lastIndexOf('/') + 1);

            this.showLoading();

            // 检测设备类型
            if (this.isMobile()) {
                // 移动端：尝试使用 navigator.share
                if (navigator.share) {
                    try {
                        // 直接分享 URL，不获取 blob
                        await navigator.share({
                            url: link,
                            title: '视频下载',
                            text: '点击下载视频'
                        });
                        this.hideLoading();
                        this.$message.success('分享成功');
                        return;
                    } catch (shareError) {
                        console.error('分享失败:', shareError);
                    }
                }
            }

            // PC 端或分享失败：使用新窗口打开
            this.hideLoading();
            this.$message.info('将在新窗口打开视频，请右键选择"视频另存为"');

            // 延迟一下再打开，避免被浏览器拦截
            setTimeout(() => {
                window.open(link, '_blank');
            }, 300);
        },

        downloadFile(url, fileName) {
            // 直接跳转到下载链接，而不是创建临时元素
            window.location.href = url;
            // this.showNotification('下载开始了 (Download started)');
        },
        showLoading() {
            this.$message.warning('下载资源中...');
        },
        hideLoading() {
            this.$message.warning('下载资源中...');
        },
        retryDownload() {
            console.log('尝试重新下载');
            window.location.reload();
        },
        isMobile() {
            return /Mobi|Android/i.test(navigator.userAgent);
        },

        // 保存图片
        saveImage() {
            if (!this.wxImage) {
                console.warn('没有可保存的图片');
                return;
            }

            this.downloadImage(this.wxImage)
        },

        downLoadAll() {
            if (this.imageList.length === 0) {
                this.$message.warning('没有可保存的图片');
                return;
            }

            // 检测设备类型并给出相应提示
            if (this.isIOS()) {
                alert('请点击"允许/下载"将图片保存到相册\n如果未弹出保存提示，请长按图片手动保存');
            }

            this.downloadImagesSequentially();
        },

        isIOS() {
            return /iPad|iPhone|iPod/.test(navigator.userAgent);
        },

        isAndroid() {
            return /Android/.test(navigator.userAgent);
        },

        async downloadImagesSequentially() {
            if (this.imageList.length > 0) {
                let successCount = 0;
                let failCount = 0;

                for (let i = 0; i < this.imageList.length; i++) {
                    try {
                        await this.downloadImage(this.imageList[i], i);
                        successCount++;
                    } catch (error) {
                        failCount++;
                        console.error(`保存第${i + 1}张图片时出错:`, error);
                    }

                    // 添加延迟，避免同时触发多个下载导致问题
                    await new Promise(resolve => setTimeout(resolve, 500));
                }
            }
        },

        downloadImage(i, index) {
            let originalUrl = i.replace("https://", location.origin + "/");
            console.log(originalUrl);
            return new Promise((resolve, reject) => {
                fetch(originalUrl).then(response => {
                    if (!response.ok) {
                        throw new Error("Network response was not ok");
                    }
                    return response.blob();
                }).then(blob => {
                    // 创建一个隐藏的a标签用于触发下载
                    const link = window.document.createElement("a");
                    link.download = `图片-${index + 1}.jpg`;
                    link.href = window.URL.createObjectURL(blob);
                    link.style.display = 'none';

                    // 添加到文档中
                    document.body.appendChild(link);

                    // 针对iOS设备的特殊处理
                    if (this.isIOS()) {
                        // 在iOS中，我们直接在当前窗口打开图片，用户可以长按照片保存
                        try {
                            // 创建一个临时的图片元素，用于在iOS中更好地显示保存选项
                            const img = document.createElement('img');
                            img.src = link.href;
                            img.style.cssText = 'position:fixed;top:0;left:0;width:1px;height:1px;z-index:-1;opacity:0;';
                            document.body.appendChild(img);

                            // 触发下载
                            link.click();

                            // 延迟清理
                            setTimeout(() => {
                                document.body.removeChild(img);
                                document.body.removeChild(link);
                                window.URL.revokeObjectURL(link.href);
                                resolve();
                            }, 2000);
                        } catch (e) {
                            document.body.removeChild(link);
                            window.URL.revokeObjectURL(link.href);
                            reject(e);
                        }
                    } else {
                        // Android和其他设备使用点击方式
                        link.click();

                        // 延迟清理资源
                        setTimeout(() => {
                            document.body.removeChild(link);
                            window.URL.revokeObjectURL(link.href);
                            resolve();
                        }, 1000);
                    }
                }).catch(error => {
                    console.error("图片下载失败:", error);
                    reject(error);
                });
            })
        },

        async handleClick(app) {
            if (this.isWechatBrowser()) {
                this.isShowTips = true;
                return;
            } else {
                this.app = app;

                console.log('当前点击的App', this.app);
                if (app.itemType == 100010 || app.itemType == 150090 || app.itemType == 170010 || app.itemType == 170020 || app.itemType == 170030 || app.itemType == 170050 || app.itemType == 190010 || app.itemType == 190020 || app.itemType == 190030) {
                    //  新打开一个页面
                    window.open(app.outUrl, '_blank');
                } else if (app.itemType == 150010 || app.itemType == 150020 || app.itemType == 150030 || app.itemType == 150040 || app.itemType == 150050 || app.itemType == 150060 || app.itemType == 150070
                ) {
                    console.log(this.shopId);
                    console.log(this.app.itemType);
                    try {
                        const res = await publishWxPyqForNfc({
                            shopId: this.shopId,
                            mtype: this.app.itemType,
                        });
                        if (res.code == 0) {
                            this.$message.error(res.msg);
                        }
                        if (res.code == 1) {
                            this.imageList = JSON.parse(res.data.images);
                            this.chatAiContentAgent = app.chatAiContentAgent;
                            this.isShowPyq = true;
                        }

                        const temp = {
                            150010: 1,
                            150020: 2,
                            150030: 3,
                            150050: 4,
                            150040: 5,
                            150060: 6,
                            150070: 7,
                            // 150090: 10,
                        }

                        console.log('@@@', temp[this.app.itemType]);

                        const res2 = await openSahreLinkForNfc({
                            shopId: this.shopId,
                            mtype: temp[this.app.itemType],
                        });
                        console.log(res2);
                        if (res2.code == 0) {
                            this.$message.error(res2.msg);
                        }
                        if (res2.code == 1) {
                            // this.outAppUrl = res2.data.reviewUrl;
                            this.outAppUrl = res2.data.url || res2.data.reviewUrl;
                            console.log('outAppUrl', this.outAppUrl);
                        }

                    } catch (error) {
                        console.log('error', error);
                    }
                } else if (app.itemType == 150080) {
                    const res2 = await openSahreLinkForNfc({
                        shopId: this.shopId,
                        mtype: 8,
                    });
                    if (res2.code == 0) {
                        this.$message.error(res2.msg);
                    }
                    if (res2.code == 1) {
                        // this.outAppUrl = res2.data.reviewUrl;
                        this.outAppUrl = res2.data.url || res2.data.reviewUrl;
                        console.log(this.outAppUrl);
                        this.isShowSPH = true;
                    }
                }
                else if (this.app.itemType == 160020) {
                    const res = await publishXhsImagesForNfc({ shopId: this.shopId });
                    if (res.code == 0) {
                        window.alert(res.msg);
                    }
                    if (res.code == 1) {
                        this.xhsData = res.data;
                        this.imageList = JSON.parse(res.data.images);
                        this.chatAiContentAgent = res.data.content;
                        this.isShowPyq = true;
                    }


                    // if (this.app.isEnableAi == 1) {
                    //     await this.reCreateText();
                    // }

                    // 小红书图文发布
                    // const res = await publishXhsImagesForNfc({ shopId: this.shopId });
                    // if (res.code == 0) {
                    //     window.alert(res.msg);
                    // }

                    // if (res.code == 1) {
                    //     console.log('title', this.app.xhsItemTitle);
                    //     console.log('content', res.data.content);


                } else if (this.app.itemType == 160030) {
                    // 携程发布图文
                    const res = await publishCtripImagesForNfc({
                        shopId: this.shopId,
                        mtype: this.app.itemType
                    });
                    if (res.code == 0) {
                        window.alert(res.msg);
                    }
                    if (res.code == 1) {
                        this.imageList = JSON.parse(res.data.images);
                        this.chatAiContentAgent = app.chatAiContentAgent;
                        this.outAppUrl = res.data.url;
                        this.isShowPyq = true;
                    }
                } else if (app.itemType == 170040) {
                    const res2 = await openSahreLinkForNfc({
                        shopId: this.shopId,
                        mtype: 9,
                    });
                    if (res2.code == 0) {
                        window.alert(res.msg);
                    }
                    if (res2.code == 1) {
                        // this.outAppUrl = res2.data.reviewUrl;
                        this.outAppUrl = res2.data.url || res2.data.reviewUrl;
                        console.log(this.outAppUrl);

                        this.isShowSPH = true;
                    }
                }
                else if (app.itemType == 110010) {
                    // 微信小程序支付
                    try {
                        const res = await publishWxOrZfbForNfc({
                            shopId: this.shopId,
                            mtype: 2,
                            miniAppPlatformType: 1
                        })

                        if (res.code == 0) {
                            window.alert(res.msg);
                        }

                        if (res.code == 1) {
                            // 为了解决 iOS Safari 无法打开新窗口的问题，先创建窗口再写入URL
                            const newWindow = window.open('', '_blank');
                            if (newWindow) {
                                newWindow.location = res.data.url;
                            } else {
                                // 如果弹窗被阻止，提供备用方案
                                window.location.href = res.data.url;
                            }
                        }
                    } catch (error) {
                        console.log(error);
                    }
                }
                else if (app.itemType == 110020) {
                    // 支付宝小程序
                    try {
                        const res = await publishWxOrZfbForNfc({
                            shopId: this.shopId,
                            mtype: 2,
                            miniAppPlatformType: 2
                        })

                        if (res.code == 0) {
                            window.alert(res.msg);
                        }

                        if (res.code == 1) {
                            // 为了解决 iOS Safari 无法打开新窗口的问题，先创建窗口再写入URL
                            const newWindow = window.open('', '_blank');
                            if (newWindow) {
                                newWindow.location = res.data.url;
                            } else {
                                // 如果弹窗被阻止，提供备用方案
                                window.location.href = res.data.url;
                            }
                        }
                    } catch (error) {
                        console.log(error);
                    }
                }
                else if (app.itemType == 140010) {
                    // 抖音视频发布
                    try {
                        const res = await publishDyVideoForNfc({ shopId: this.shopId });
                        if (res.code == 0) {
                            window.alert(res.msg);
                        }
                        if (res.code == 1) {
                            window.location.href = res.data.jsShareUri;
                        }
                    } catch (error) {
                        console.log(error);
                    }
                }
                else if (app.itemType == 140020) {
                    // 快手视频发布
                    try {
                        const res = await publishKsVideoForNfc({ shopId: this.shopId });
                        if (res.code == 0) {
                            window.alert(res.msg);
                        }

                        if (res.code == 1) {
                            window.location.href = res.data.url;
                        }
                    } catch (error) {
                        console.log(error);
                    }
                } else if (app.itemType == 140030) {
                    // 小红书视频发布
                    try {
                        const res = await publishXhsVideoForNfc({ shopId: this.shopId });
                        if (res.code == 0) {
                            window.alert(res.msg);
                        }
                        if (res.code == 1) {
                            this.xhsData = res.data;
                            this.chatAiContentAgent = res.data.content;
                            this.videoUrl = res.data.video;
                            this.isShowPyq = true;
                        }


                        // 532484
                        // const res = await publishXhsVideoForNfc({ shopId: this.shopId });
                        // if (res.code == 0) {
                        //     window.alert(res.msg);
                        // }

                        // if (res.code == 1) {
                        //     xhs.share({
                        //         shareInfo: {
                        //             type: 'video', // 必填，笔记类型 'video' | 'normal'
                        //             title: res.data.title, // 笔记标题
                        //             content: res.data.content, // 笔记正文
                        //             images: [],//图文类型必填，笔记图片，必须是服务器地址，暂时不支持本地文件
                        //             video: res.data.video, // 视频类型必填，必须是服务器地址
                        //             cover: res.data.cover // 视频封面图，必须是服务器地址，暂时不支持本地文件
                        //         },
                        //         verifyConfig: {
                        //             appKey: res.data.appKey, //必填，应用的唯一标识,
                        //             nonce: res.data.nonce, // 必填，服务端生成签名的随机字符串
                        //             timestamp: res.data.timestamp, // 必填，服务端生成签名的时间戳
                        //             signature: res.data.signature // 必填，服务端生成的签名
                        //         },
                        //         fail: (e) => {
                        //             // 调用失败时执行的回调函数
                        //             console.log(e)
                        //         },
                        //     })
                        // }
                    } catch (error) {
                        console.log(error);
                    }
                } else if (app.itemType == 140040) {
                    // 视频号
                    console.log(app);

                    const res = await findPpCardWorkVideo({
                        shopId: this.shopId,
                        mtype: app.itemType,
                    });
                    if (res.code == 0) {
                        this.$message.error(res.msg);
                    }
                    if (res.code == 1) {
                        this.chatAiContentAgent = res.data.content;
                        this.videoUrl = res.data.video;
                        this.isShowPyq = true;
                    }
                } else if (app.itemType == 180010) {
                    // wifi连接
                    try {
                        const res = await openLinkWxWifiForNfc({ shopId: this.shopId })
                        if (res.code == 0) {
                            window.alert(res.msg);
                        }
                        if (res.code == 1) {
                            const appId = res.data.appid || 'wx2db9dbd110aca402';
                            const path = 'pages/index/index';
                            const queryParams = {
                                name: encodeURIComponent(app.wifiName),
                                password: encodeURIComponent(app.password),
                                mtype: 'wifi',
                            }
                            const urlScheme = `weixin://dl/business/?appid=${appId}&path=${path}&query=${encodeURIComponent(`name=${queryParams.name}&password=${queryParams.password}&mtype=wifi`)}`

                            console.log(urlScheme);
                            // window.open(urlScheme, '_blank');

                            const newWindow = window.open('', '_blank');
                            if (newWindow) {
                                newWindow.location = urlScheme;
                            } else {
                                // 如果弹窗被阻止，提供备用方案
                                window.location.href = urlScheme;
                            }
                        }

                    } catch (error) {
                        console.log(error);
                    }
                } else if (app.itemType == 180030) {
                    // 微信二维码
                    this.wxImage = app.itemImage;
                    this.maskShow = true;

                } else if (app.itemType == 160010) {
                    this.imageList = [];
                    this.chatAiContentAgent = '';

                    try {
                        const res = await publishWxPyqForNfc({
                            shopId: this.shopId,
                            mtype: this.app.itemType,
                        });
                        if (res.code == 0) {
                            window.alert(res.msg);
                        }
                        if (res.code == 1) {
                            this.imageList = JSON.parse(res.data.images);
                            this.chatAiContentAgent = app.chatAiContentAgent;
                            this.isShowPyq = true;
                        }
                    } catch (error) {
                        console.log(error);
                    }
                }
            }
        },

        async DZdaka() {
            try {
                const res = await openSahreLinkForNfc({
                    shopId: this.shopId,
                    mtype: 1
                });

                if (res.code == 0) {
                    window.alert(res.msg);
                }

                if (res.code == 1) {
                    window.location.href = res.data.url;
                }
            } catch (error) {
                console.log(error);
            }
        },

        async DZdaka_comment() {
            this.imageList = [];
            this.chatAiContentAgent = '';

            console.log(this.app);
            try {
                const res = await publishWxPyqForNfc({
                    shopId: this.shopId,
                    mtype: this.app.itemType,
                });
                if (res.code == 0) {
                    window.alert(res.msg);
                }
                if (res.code == 1) {
                    this.imageList = JSON.parse(res.data.images);
                    this.chatAiContentAgent = this.app.chatAiContentAgent;

                    this.isShowDZdaka = false;
                    this.isShowPyq = true;
                }
            } catch (error) {
                console.log(error);
            }
        },

        async comment() {
            console.log('评论', this.app);
            if (this.app.itemType == 140040) {
                // 发视频号
                const urlScheme = `weixin://`;
                window.location.href = urlScheme;
                return;
            } else if (this.app.itemType == 150010) {
                // 大众打卡
                try {
                    const res = await openSahreLinkForNfc({
                        shopId: this.shopId,
                        mtype: 1
                    });

                    if (res.code == 0) {
                        window.alert(res.msg);
                    }

                    if (res.code == 1) {
                        const newWindow = window.open('', '_blank');
                        if (newWindow) {
                            newWindow.location = res.data.url;
                        } else {
                            window.location.href = res.data.url;
                        }
                    }
                } catch (error) {
                    console.log(error);
                }
            } else if (this.app.itemType == 150020) {
                // 抖音打卡
                try {
                    const res = await openSahreLinkForNfc({
                        shopId: this.shopId,
                        mtype: 2
                    });

                    if (res.code == 0) {
                        window.alert(res.msg);
                    }
                    if (res.code == 1) {
                        window.location.href = 'snssdk1128://poi/detail/?id=' + res.data.url;
                        // const newWindow = window.open('', '_blank');
                        // if (newWindow) {
                        //     newWindow.location = res.data.url;
                        // } else {
                        //     window.location.href = res.data.url;
                        // }
                    }
                } catch (error) {
                    console.log(error);
                }
            } else if (this.app.itemType == 150030) {
                // 高德打卡
                try {
                    const res = await openSahreLinkForNfc({
                        shopId: this.shopId,
                        mtype: 3
                    });

                    if (res.code == 0) {
                        window.alert(res.msg);
                    }

                    if (res.code == 1) {
                        const newWindow = window.open('', '_blank');
                        if (newWindow) {
                            newWindow.location = res.data.url;
                        } else {
                            window.location.href = res.data.url;
                        }
                    }
                } catch (error) {
                    console.log(error);
                }
            } else if (this.app.itemType == 150040) {
                // 百度打卡
                try {
                    const res = await openSahreLinkForNfc({
                        shopId: this.shopId,
                        mtype: 5
                    });

                    if (res.code == 0) {
                        window.alert(res.msg);
                    }

                    if (res.code == 1) {
                        const newWindow = window.open('', '_blank');
                        if (newWindow) {
                            newWindow.location = res.data.url;
                        } else {
                            window.location.href = res.data.url;
                        }
                    }
                } catch (error) {
                    console.log(error);
                }
            } else if (this.app.itemType == 150050) {
                // // 美团打卡
                // try {
                //     const res = await openSahreLinkForNfc({
                //         shopId: this.shopId,
                //         mtype: 4
                //     });

                //     if (res.code == 0) {
                //         window.alert(res.msg);
                //     }

                //     if (res.code == 1) {
                //         const newWindow = window.open('', '_blank');
                //         if (newWindow) {
                //             newWindow.location = res.data.url;
                //         } else {
                //             window.location.href = res.data.url;
                //         }
                //     }
                // } catch (error) {
                //     console.log(error);
                // }
            } else if (this.app.itemType == 160010) {
                const urlScheme = `weixin://`;
                window.location.href = urlScheme;
                return;
            } else if (this.app.itemType == 160020) {
                xhs.share({
                    shareInfo: {
                        type: 'normal', // 必填，笔记类型 'video' | 'normal'
                        title: this.app.xhsItemTitle, // 笔记标题
                        // this.app.isEnableAi == 1 ? this.chatAiContentAgent :
                        content: this.xhsData.content,
                        images: JSON.parse(this.xhsData.images),//图文类型必填，笔记图片，必须是服务器地址，暂时不支持本地文件
                        video: '', // 视频类型必填，必须是服务器地址
                        cover: this.xhsData.cover // 视频封面图，必须是服务器地址，暂时不支持本地文件
                    },
                    verifyConfig: {
                        appKey: this.xhsData.appKey, //必填，应用的唯一标识,
                        nonce: this.xhsData.nonce, // 必填，服务端生成签名的随机字符串
                        timestamp: this.xhsData.timestamp, // 必填，服务端生成签名的时间戳
                        signature: this.xhsData.signature // 必填，服务端生成的签名
                    },
                    fail: (e) => {
                        // 调用失败时执行的回调函数
                        console.log(e)
                    },
                })
            } else if (this.app.itemType == 140030) {
                xhs.share({
                    shareInfo: {
                        type: 'video', // 必填，笔记类型 'video' | 'normal'
                        title: this.xhsData.title, // 笔记标题
                        content: this.xhsData.content, // 笔记正文
                        images: [],//图文类型必填，笔记图片，必须是服务器地址，暂时不支持本地文件
                        video: this.xhsData.video, // 视频类型必填，必须是服务器地址
                        cover: this.xhsData.cover // 视频封面图，必须是服务器地址，暂时不支持本地文件
                    },
                    verifyConfig: {
                        appKey: this.xhsData.appKey, //必填，应用的唯一标识,
                        nonce: this.xhsData.nonce, // 必填，服务端生成签名的随机字符串
                        timestamp: this.xhsData.timestamp, // 必填，服务端生成签名的时间戳
                        signature: this.xhsData.signature // 必填，服务端生成的签名
                    },
                    fail: (e) => {
                        // 调用失败时执行的回调函数
                        console.log(e)
                    },
                })
            }
        },

        async comment2() {
            if (this.xhsData.content) {
                this.chatAiContentAgent = this.xhsData.content;
            }
            this.copyText(); 

            if (this.app.itemType == 160020) {
                xhs.share({
                    shareInfo: {
                        type: 'normal', // 必填，笔记类型 'video' | 'normal'
                        title: this.app.xhsItemTitle, // 笔记标题
                        // this.app.isEnableAi == 1 ? this.chatAiContentAgent :
                        content: this.xhsData.content,
                        images: JSON.parse(this.xhsData.images),//图文类型必填，笔记图片，必须是服务器地址，暂时不支持本地文件
                        video: '', // 视频类型必填，必须是服务器地址
                        cover: this.xhsData.cover // 视频封面图，必须是服务器地址，暂时不支持本地文件
                    },
                    verifyConfig: {
                        appKey: this.xhsData.appKey, //必填，应用的唯一标识,
                        nonce: this.xhsData.nonce, // 必填，服务端生成签名的随机字符串
                        timestamp: this.xhsData.timestamp, // 必填，服务端生成签名的时间戳
                        signature: this.xhsData.signature // 必填，服务端生成的签名
                    },
                    fail: (e) => {
                        // 调用失败时执行的回调函数
                        console.log(e)
                    },
                })
            } else if (this.app.itemType == 140030) {
                xhs.share({
                    shareInfo: {
                        type: 'video', // 必填，笔记类型 'video' | 'normal'
                        title: this.xhsData.title, // 笔记标题
                        content: this.xhsData.content, // 笔记正文
                        images: [],//图文类型必填，笔记图片，必须是服务器地址，暂时不支持本地文件
                        video: this.xhsData.video, // 视频类型必填，必须是服务器地址
                        cover: this.xhsData.cover // 视频封面图，必须是服务器地址，暂时不支持本地文件
                    },
                    verifyConfig: {
                        appKey: this.xhsData.appKey, //必填，应用的唯一标识,
                        nonce: this.xhsData.nonce, // 必填，服务端生成签名的随机字符串
                        timestamp: this.xhsData.timestamp, // 必填，服务端生成签名的时间戳
                        signature: this.xhsData.signature // 必填，服务端生成的签名
                    },
                    fail: (e) => {
                        // 调用失败时执行的回调函数
                        console.log(e)
                    },
                })
            }
        },

        closePopup() {
            this.isShowSPH = false;
        },

        addMenu(tag) {
            const foundTag = this.tagList.find(item => item.label === tag.label);
            if (foundTag) {
                // 如果当前是 success 状态，检查是否是最后一个选中的标签
                if (foundTag.type === 'success') {
                    // 计算当前有多少个选中的标签
                    const selectedCount = this.tagList.filter(item => item.type === 'success').length;

                    // 如果这是最后一个选中的标签，则不允许取消选中
                    if (selectedCount <= 1) {
                        // 保持选中状态，或者给出提示
                        this.$message.warning('至少需要选中一个商品');
                        return; // 阻止切换操作
                    }

                    // 如果不是最后一个选中的标签，则可以切换为 info
                    foundTag.type = 'info';
                } else {
                    // 当前是 info 状态，可以切换为 success
                    foundTag.type = 'success';
                }
            }
        },

        setFeature(tag) {
            const foundTag = this.featureList.find(item => item.label === tag.label);
            if (foundTag) {
                if (foundTag.type !== '') {
                    foundTag.type = '';
                } else {
                    foundTag.type = 'info';
                }
            }
        },

        setTheme(tag) {
            const foundTag = this.themeList.find(item => item.label === tag.label);
            if (foundTag) {
                this.themeList.forEach(item => {
                    item.type = 'info';
                })
                if (foundTag.type !== 'warning') {
                    foundTag.type = 'warning';
                } else {
                    foundTag.type = 'info';
                }
            }
        },

        setConfirm() {
            if (Array.isArray(this.tagList) && this.tagList.length > 0) {
                this.aiSetTheme.goods =
                    this.tagList
                        .filter(item => item.type === 'success')
                        .map(item => item.label)
                        .join(',');
            } else {
                this.aiSetTheme.goods = '';
            }

            if (Array.isArray(this.featureList) && this.featureList.length > 0) {
                this.aiSetTheme.require =
                    this.featureList
                        .filter(item => item.type === '')
                        .map(item => item.label)
                        .join(',');
            } else {
                this.aiSetTheme.require = '';
            }

            if (Array.isArray(this.themeList) && this.themeList.length > 0) {
                this.aiSetTheme.theme =
                    this.themeList
                        .filter(item => item.type === 'warning')
                        .map(item => item.label)
                        .join(',');
            } else {
                this.aiSetTheme.theme = '';
            }

            this.isSetText = false;

            this.reCreateText();
        },

        clickImg(img) {
            if (img.outUrl == '') return;
            const newWindow = window.open('', '_blank');
            if (newWindow) {
                newWindow.location = `${img.outUrl}`;
            } else {
                window.location.href = `${img.outUrl}`;
            }
        },
    },

};
</script>

<style lang="less" scoped>
.pages {
    position: relative;
    background: radial-gradient(72.67% 37.85% at 11.666666666666666% 42.1875%, rgba(199, 218, 255, 1) 0%, rgba(242, 245, 255, 1) 100%);
    min-height: 100vh;
    overflow-y: auto;
}

.bg {
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
}

.first {
    position: relative;
    padding: 43px 16px;
}

.add-box {
    display: flex;
    align-items: center;

    height: 80px;
    border-radius: 5px;
    background: linear-gradient(0, rgba(243, 231, 233, 0.9) 0%, rgba(227, 238, 255, 0.9) 99%, rgba(227, 238, 255, 0.9) 100%);

    box-sizing: border-box;
    padding: 10px;

    cursor: pointer;

    margin: 14px 0;

    img {
        width: 48px;
        height: 48px;

        margin-right: 5px;
    }

    .font-text {
        // flex: 1;
        width: 100%;
        display: flex;
        flex-direction: column;

        &-1 {
            // width: 100%;
            // max-width: 146px;
            max-width: 240px;
            font-size: 20px;
            color: rgba(67, 79, 105, 1);

            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
        }

        &-2 {
            // width: 100%;
            // max-width: 146px;
            max-width: 260px;
            font-size: 16px;
            color: rgba(0, 0, 0, 1);

            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
        }
    }

    // &-btn {
    //     display: flex;
    //     align-items: center;
    //     justify-content: center;

    //     width: 50px;
    //     height: 18px;
    //     border-radius: 93px;
    //     background: rgba(204, 221, 252, 1);

    //     font-size: 10px;

    //     margin-left: auto;

    //     span {
    //         width: 29px;

    //         white-space: nowrap;
    //         text-overflow: ellipsis;
    //         overflow: hidden;
    //     }
    // }
}

.title-box {
    width: 100%;
    height: 85px;

    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;

    border-radius: 2px;

    border: 1px dashed rgba(157, 157, 158, 1);
    cursor: pointer;
}

.title-box .title {
    font-size: 29px;
    line-height: 42px;
    color: #000000;
}

.title-box .subtitle {
    font-size: 13px;
    line-height: 19px;
    color: #000000;
}

/* 模板一 */
.app-box-type-1 {
    width: 100%;

    margin-top: 10px;

    cursor: pointer;

    -webkit-tap-highlight-color: transparent; // 禁用安卓点击高亮
    -webkit-touch-callout: none; // 禁止长按弹出菜单
    user-select: none; // 禁止文字选择
    touch-action: manipulation; // 更流畅的触摸交互
    outline: none; // 移除焦点边框
}

.app-box-type-1 .app-list {
    display: flex;
    flex-wrap: wrap;

    margin: 0 -5px;
}

.app-box-type-1 .app-list .app-item {
    display: flex;
    flex-direction: column;
    align-items: center;

    width: 30%;
    height: 115px;

    background: rgba(255, 255, 255, 1);
    border-radius: 12px;

    margin: 0 5px 10px;
}

.app-box-type-1 .app-list .app-item-img {
    width: 34px;
    height: 34px;

    margin-top: 23px;
    margin-bottom: 12px;
}

.app-box-type-1 .app-list .app-item-text1 {
    width: 100%;

    text-align: center;
    font-size: 11px;
    color: rgba(0, 0, 0, 1);

    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;

    margin-bottom: 2px;
}

.app-box-type-1 .app-list .app-item-text2 {
    width: 100%;

    text-align: center;
    font-size: 8px;
    color: rgba(157, 157, 158, 1);

    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

/* 模板二 */
.app-box-type-2 {
    width: 100%;

    margin-top: 17px;

    cursor: pointer;

    -webkit-tap-highlight-color: transparent; // 禁用安卓点击高亮
    -webkit-touch-callout: none; // 禁止长按弹出菜单
    user-select: none; // 禁止文字选择
    touch-action: manipulation; // 更流畅的触摸交互
    outline: none; // 移除焦点边框
}

.app-box-type-2 .app-item {
    display: flex;
    align-items: center;

    height: 85px;

    background-color: #fff;
    border-radius: 12px;

    box-sizing: border-box;
    padding: 22px 20px;

    margin-top: 14px;
}

.app-box-type-2 .app-item img {
    width: 42px;
    height: 42px;

    margin-right: 13px;
}

.app-box-type-2 .app-item-text1 {
    width: 170px;
    font-size: 16px;
    color: rgba(0, 0, 0, 1);

    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

.app-box-type-2 .app-item-text2 {
    width: 170px;
    font-size: 11px;
    color: rgba(157, 157, 158, 1);

    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;

    margin-top: 2px;
}

/* 模板三 */
.app-box-type-3 {
    cursor: pointer;

    -webkit-tap-highlight-color: transparent; // 禁用安卓点击高亮
    -webkit-touch-callout: none; // 禁止长按弹出菜单
    user-select: none; // 禁止文字选择
    touch-action: manipulation; // 更流畅的触摸交互
    outline: none; // 移除焦点边框
}

.app-box-type-3 .app-list {
    margin: 0 -3.5px;
}

.app-box-type-3 .app-title {
    margin: 10px 0;
}

.app-box-type-3 .app-item {
    width: 30%;
    height: 54px;

    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;

    border-radius: 3px;
    background-color: #fff;

    margin: 0 3.5px 7px;
}

.app-box-type-3 .app-item-img {
    width: 24px;
    height: 24px;
    border-radius: 50%;
}

.app-box-type-3 .app-item-text {
    width: 100%;

    text-align: center;
    font-size: 9px;
    color: rgba(0, 0, 0, 1);

    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;

    margin-top: 3px;
}

.app-box-type-3 .goods-list {
    box-sizing: border-box;
    padding: 9px 15px;

    background-color: #fff;
    border-radius: 13px;

    margin-top: 10px;

    &-title {
        font-size: 16px;
        font-weight: 700;
        color: rgba(0, 0, 0, 1);

        margin-bottom: 10px;
    }

    :last-child {
        margin-bottom: 0;
    }

    &-item {
        display: flex;

        margin-bottom: 30px;

        .goods-img {
            width: 83px;
            height: 83px;

            border-radius: 9px;

            margin-right: 10px;
        }

        .goods-info {
            display: flex;
            flex-direction: column;
            justify-content: space-between;

            width: 100%;

            &-title {
                font-size: 14px;
                font-weight: 700;
                color: rgba(0, 0, 0, 1);
            }

            &-subtitle {
                font-size: 12px;
                color: rgba(157, 157, 158, 1);
            }

            &-price {
                display: flex;
                align-items: center;
                justify-content: space-between;

                .goods-price1 {
                    font-size: 12px;
                    font-weight: 700;
                    color: rgba(232, 72, 9, 1);
                }

                .goods-price2 {
                    font-size: 12px;
                    text-decoration-line: line-through;
                    color: rgba(199, 199, 199, 1);
                }

                .goods-btn {
                    width: 56px;
                    height: 27px;

                    text-align: center;
                    line-height: 27px;
                    color: #fff;
                    font-size: 13px;

                    border-radius: 200px;
                    background: rgba(232, 72, 9, 1);
                }
            }


        }
    }
}

// 模版4
.model4 {
    &-title {
        height: 128px;

        background: url('../assets/img/common/bg1.png') no-repeat;
        background-size: cover;

        box-sizing: border-box;
        padding: 17px 11px;

        .title {
            font-size: 20px;
            font-weight: 700;
        }

        .subtitle {
            font-size: 11px;
            margin: 6px 0;
        }

        .shop {
            width: 147px;
            height: 28px;

            display: flex;
            align-items: center;

            border-radius: 14px;
            background: rgba(255, 255, 255, 0.8);

            box-sizing: border-box;
            padding: 4px 9px;

            &-img {
                width: 24px;
                height: 20px;

                margin-right: 8px;
            }

            &-text {
                flex: 1;

                font-size: 10px;
                color: rgba(67, 79, 105, 1);

                white-space: nowrap;
                overflow: hidden;
                text-overflow: ellipsis;
            }
        }
    }

    .app-box-type-4 {
        position: relative;
        cursor: pointer;

        padding: 0 10px;
        margin-top: -18px;

        .app-list {
            border-radius: 15px;
            background: rgba(255, 255, 255, 0.9);

            box-sizing: border-box;
            padding: 10px 13px 0 13px;

            margin-bottom: 10px;
        }

        .app-title {
            font-size: 13px;
            font-weight: 700;

            margin-bottom: 12px;
        }

        .app-item {
            width: 25%;

            display: flex;
            flex-direction: column;
            align-items: center;
            text-align: center;

            margin-bottom: 17px;

            &-img {
                width: 30px;
                height: 30px;
                border-radius: 50%;

                margin-bottom: 7px;
            }

            &-text {
                width: 100%;

                text-align: center;
                font-size: 10px;
                color: rgba(0, 0, 0, 1);

                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
            }
        }

        .goods-list {
            box-sizing: border-box;
            padding: 7px 13px;

            background: rgba(255, 255, 255, 0.8);
            border-radius: 11px;

            margin-top: 8px;

            &-title {
                font-size: 13px;
                font-weight: 700;
                color: rgba(0, 0, 0, 1);

                margin-bottom: 10px;
            }

            :last-child {
                margin-bottom: 0;
            }

            &-item {
                display: flex;

                padding-bottom: 10px;
                border-bottom: 0.5px solid rgba(227, 227, 227, 0.8);

                margin-bottom: 13px;

                &:last-child {
                    border-bottom: none;
                }

                .goods-img {
                    width: 66px;
                    height: 66px;

                    border-radius: 7px;

                    margin-right: 10px;
                }

                .goods-info {
                    display: flex;
                    flex-direction: column;
                    justify-content: space-between;

                    width: 100%;

                    &-title {
                        font-size: 14px;
                        font-weight: 700;
                        color: rgba(0, 0, 0, 1);
                    }

                    &-subtitle {
                        font-size: 12px;
                        color: rgba(157, 157, 158, 1);
                    }

                    &-price {
                        display: flex;
                        align-items: center;
                        justify-content: space-between;

                        .goods-price1 {
                            font-size: 12px;
                            font-weight: 700;
                            color: rgba(232, 72, 9, 1);
                        }

                        .goods-price2 {
                            font-size: 12px;
                            text-decoration-line: line-through;
                            color: rgba(199, 199, 199, 1);
                        }

                        .goods-btn {
                            width: 56px;
                            height: 27px;

                            text-align: center;
                            line-height: 27px;
                            color: #fff;
                            font-size: 13px;

                            border-radius: 200px;
                            background: rgba(232, 72, 9, 1);
                        }
                    }
                }
            }
        }
    }
}

// 模版5
.model5 {
    &-title {
        height: 150px;

        // background: url("../assets/img/common/bg1.png") no-repeat;
        // background-size: cover;

        box-sizing: border-box;
        padding: 49px 11px 0;

        .title {
            font-size: 24px;
            font-weight: 700;
        }

        .shop {
            width: 147px;
            height: 37px;

            display: flex;
            align-items: center;

            margin-top: 15px;

            &-img {
                width: 37px;
                height: 37px;

                margin-right: 12px;

                border-radius: 50%;
            }

            &-text {
                flex: 1;

                font-size: 15px;

                white-space: nowrap;
                overflow: hidden;
                text-overflow: ellipsis;
            }
        }
    }

    .app-box-type-5 {
        position: relative;
        cursor: pointer;

        padding: 0 10px;

        .four-img {
            display: flex;
            margin: 4px 0;

            &-box {
                width: 25%;
                height: 150px;

                box-sizing: border-box;
                padding: 0 2px;

                border-radius: 4px;

                &-item {
                    width: 100%;
                    height: 150px;

                    display: flex;
                    align-items: center;
                    justify-content: center;

                    // border: 1px dashed #cccccc;
                }

                &-img {
                    width: 100%;
                    height: 150px;
                }
            }
        }

        .three-img {
            .three-img-top {

                &-box {
                    display: flex;
                    align-items: center;
                    justify-content: center;

                    width: 100%;
                    height: 180px;
                    border-radius: 5px;

                    overflow: hidden;
                }

                &-img {
                    width: 100%;
                    height: 180px;
                    border-radius: 5px;
                }

            }

            .three-img-bottom {
                .i-box {
                    display: flex;
                    margin: 5px -5px 0;

                    &-item {
                        flex: 1;
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        text-align: center;

                        box-sizing: border-box;
                        margin: 0 5px;

                        &-img {
                            width: 100%;
                            height: 130px;

                            border-radius: 5px;
                        }

                        &-empty {
                            display: flex;
                            align-items: center;
                            justify-content: center;
                            width: 100%;
                            height: 130px;

                            border-radius: 5px;
                        }

                        i {
                            flex: 1;
                        }
                    }

                }
            }
        }

        .app-list {
            border-radius: 15px;
            background: rgba(255, 255, 255, 0.9);

            box-sizing: border-box;
            padding: 10px 13px 0 13px;

            margin-bottom: 10px;
        }

        .app-title {
            font-size: 13px;
            font-weight: 700;

            margin-bottom: 12px;
        }

        .app-item {
            width: 25%;

            display: flex;
            flex-direction: column;
            align-items: center;
            text-align: center;

            margin-bottom: 17px;

            &-img {
                width: 30px;
                height: 30px;
                border-radius: 50%;

                margin-bottom: 7px;
            }

            &-text {
                width: 100%;

                text-align: center;
                font-size: 10px;
                color: rgba(0, 0, 0, 1);

                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
            }
        }

        .goods-list {
            box-sizing: border-box;
            padding: 7px 13px;

            background: rgba(255, 255, 255, 0.8);
            border-radius: 11px;

            margin-top: 8px;

            &-title {
                font-size: 13px;
                font-weight: 700;
                color: rgba(0, 0, 0, 1);

                margin-bottom: 10px;
            }

            :last-child {
                margin-bottom: 0;
            }

            &-item {
                display: flex;

                padding-bottom: 10px;
                border-bottom: 0.5px solid rgba(227, 227, 227, 0.8);

                margin-bottom: 13px;

                &:last-child {
                    border-bottom: none;
                }

                .goods-img {
                    width: 66px;
                    height: 66px;

                    border-radius: 7px;

                    margin-right: 10px;
                }

                .goods-info {
                    display: flex;
                    flex-direction: column;
                    justify-content: space-between;

                    width: 100%;

                    &-title {
                        font-size: 14px;
                        font-weight: 700;
                        color: rgba(0, 0, 0, 1);
                    }

                    &-subtitle {
                        font-size: 12px;
                        color: rgba(157, 157, 158, 1);
                    }

                    &-price {
                        display: flex;
                        align-items: center;
                        justify-content: space-between;

                        .goods-price1 {
                            font-size: 12px;
                            font-weight: 700;
                            color: rgba(232, 72, 9, 1);
                        }

                        .goods-price2 {
                            font-size: 12px;
                            text-decoration-line: line-through;
                            color: rgba(199, 199, 199, 1);
                        }

                        .goods-btn {
                            width: 56px;
                            height: 27px;

                            text-align: center;
                            line-height: 27px;
                            color: #fff;
                            font-size: 13px;

                            border-radius: 200px;
                            background: rgba(232, 72, 9, 1);
                        }
                    }
                }
            }
        }
    }
}

.mask {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.7);
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    z-index: 9999;

    .img-box {
        max-width: 80%;
        max-height: 70%;

        img {
            width: 100%;
            height: 100%;
            object-fit: contain;
        }
    }

    .btn-close,
    .btn-save {
        width: 120px;
        height: 40px;
        background-color: #ffffff;
        border-radius: 20px;
        display: flex;
        justify-content: center;
        align-items: center;
        margin-top: 20px;
        font-size: 16px;
        cursor: pointer;
        user-select: none;
    }

    .btn-save {
        background-color: #007AFF;
        color: #ffffff;
    }
}

.maskTips {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.7);
    z-index: 9999;

    img {
        width: 234px;
        height: 93px;
    }
}

.dzdaka-box {
    width: 90%;
    max-width: 500px;
    background: #fff;
    border-radius: 12px;
    padding: 20px;
    box-sizing: border-box;
    position: relative;

    .dzdaka-header {
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-bottom: 20px;

        h3 {
            margin: 0;
            font-size: 18px;
            font-weight: 600;
            color: #333;
        }

        .close-btn {
            width: 30px;
            height: 30px;
            border-radius: 50%;
            background: #f5f5f5;
            display: flex;
            align-items: center;
            justify-content: center;
            font-size: 20px;
            cursor: pointer;
            color: #999;

            &:hover {
                background: #e0e0e0;
            }
        }
    }

    .dzdaka-img {
        width: 100%;
    }

    .btn-box {
        display: flex;

        margin-top: 10px;

        button {
            flex: 1;
            height: 44px;
            border-radius: 22px;
            border: none;
            font-size: 16px;
            cursor: pointer;
            transition: all 0.2s;

            background: #007AFF;
            color: #fff;

            &:first-child {
                margin-right: 10px;
            }

            &:hover {
                opacity: 0.9;
            }
        }
    }
}

// 在现有样式中添加以下样式

.pyq-content {
    width: 90%;
    max-width: 500px;
    background: #fff;
    border-radius: 12px;
    padding: 20px;
    box-sizing: border-box;
    position: relative;

    .menu-set-title {
        font-size: 14px;
        font-weight: 700;

        margin: 10px 0;
    }

    .menu-set-btn {
        display: flex;
        align-items: center;
        justify-content: center;

        width: 100%;
        height: 50px;

        background: #007AFF;
        color: #fff;

        margin-top: 20px;
        border-radius: 10px;
    }

    .pyq-header {
        display: flex;
        // justify-content: space-between;
        align-items: center;
        margin-bottom: 20px;

        h3 {
            margin: 0;
            font-size: 18px;
            font-weight: 600;
            color: #333;
        }

        .close-btn {
            width: 30px;
            height: 30px;
            border-radius: 50%;
            background: #f5f5f5;
            display: flex;
            align-items: center;
            justify-content: center;
            font-size: 20px;
            cursor: pointer;
            color: #999;

            margin-left: auto;

            &:hover {
                background: #e0e0e0;
            }
        }
    }

    .pyq-section {
        margin-bottom: 5px;

        .section-title {
            font-size: 16px;
            font-weight: 600;
            color: #333;
            margin-bottom: 10px;

            .set-text {
                color: #007AFF;
                margin-left: 10px;
                cursor: pointer;
            }
        }

        .text-content {
            background: #f8f9fa;
            border-radius: 8px;
            padding: 12px;
            font-size: 14px;
            color: #666;
            line-height: 1.5;
            max-height: 100px;
            overflow-y: auto;

            margin-top: 10px;
        }
    }

    .image-grid {
        display: grid;
        grid-template-columns: repeat(3, 1fr);
        gap: 10px;

        margin-top: 10px;

        .image-item {
            aspect-ratio: 1;
            border-radius: 8px;
            overflow: hidden;
            cursor: pointer;
            position: relative;

            &:before {
                content: '';
                display: block;
                padding-top: 100%;
            }

            img {
                position: absolute;
                top: 0;
                left: 0;
                width: 100%;
                height: 100%;
                object-fit: cover;
                transition: transform 0.2s;
            }

            &:hover img {
                transform: scale(1.05);
            }
        }
    }

    .video-box {
        margin-top: 10px;

        .video {
            width: 100%;
            height: 200px;
        }
    }

    .pyq-actions {
        display: flex;
        justify-content: space-between;
        margin-top: 20px;

        button {
            flex: 1;
            height: 44px;
            border-radius: 22px;
            border: none;
            font-size: 16px;
            cursor: pointer;
            transition: all 0.2s;

            &:first-child {
                margin-right: 10px;
            }

            &:last-child {
                margin-left: 10px;
            }

            &:hover {
                opacity: 0.9;
            }
        }

        .btn-secondary {
            background: #f0f0f0;
            color: #666;
        }

        .btn-primary {
            background: #007AFF;
            color: #fff;
        }

        .btn-primary2{
            background: #1bf31b;
            color: #fff;
        }

        .btn-a {
            display: flex;
            align-items: center;
            justify-content: center;

            flex: 1;
            height: 44px;
            border-radius: 22px;
            border: none;
            font-size: 16px;
            cursor: pointer;
            transition: all 0.2s;

            background: #007AFF;
            color: #fff;

            a {
                color: #fff;
            }
        }
    }

    .tag-container {
        max-height: 140px;
        overflow-y: auto;
        padding: 5px;
    }

    /* 可选：美化滚动条 */
    .tag-container::-webkit-scrollbar {
        width: 6px;
    }

    .tag-container::-webkit-scrollbar-track {
        background: #f1f1f1;
        border-radius: 10px;
    }

    .tag-container::-webkit-scrollbar-thumb {
        background: #c1c1c1;
        border-radius: 10px;
    }

    .tag-container::-webkit-scrollbar-thumb:hover {
        background: #a8a8a8;
    }
}

.refush-btn {
    display: flex;
    align-items: center;
    justify-content: center;

    background: linear-gradient(122.68deg, rgba(201, 40, 145, 1) 0%, rgba(155, 105, 255, 1) 100%);
    color: #ffffff;
    font-size: 16px;
    border-radius: 5px;

    box-sizing: border-box;
    padding: 10px 15px;

    cursor: pointer;
    transition: all 0.2s ease;

    margin-left: auto;
    margin-bottom: 15px;

    img {
        width: 13px;
        height: 13px;

        margin-right: 5px;
    }

    .rotate {
        animation: rotate-animation 1s linear infinite;
        transform-origin: center;
    }

    @keyframes rotate-animation {
        from {
            transform: rotate(0deg);
        }

        to {
            transform: rotate(360deg);
        }
    }
}

.copy-btn {
    display: inline-block;
    padding: 6px 12px;
    background-color: #007AFF;
    color: #ffffff;
    font-size: 14px;
    border-radius: 6px;
    cursor: pointer;
    text-align: center;
    transition: all 0.2s ease;
    border: none;

    &:hover {
        background-color: #0056cc;
        transform: translateY(-1px);
    }

    &:active {
        transform: translateY(0);
    }
}

.popup-container {
    background-color: #fff;
    border-radius: 8px;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
    width: 80%;
    max-width: 360px;
    overflow: hidden;
}

.popup-header {
    padding: 20px 20px 10px;
    text-align: center;
    border-bottom: 1px solid #eee;
}

.popup-header h3 {
    margin: 0;
    color: #333;
    font-size: 18px;
}

.popup-body {
    padding: 20px;
    text-align: center;
}

.popup-body p {
    margin: 0;
    color: #666;
    font-size: 16px;
    line-height: 1.5;
}

.popup-footer {
    display: flex;
    border-top: 1px solid #eee;
}

.btn-cancel,
.btn-confirm {
    flex: 1;
    padding: 15px 0;
    border: none;
    font-size: 16px;
    cursor: pointer;
    transition: background-color 0.3s;
}

.btn-cancel {
    background-color: #f5f5f5;
    color: #666;
    border-right: 1px solid #eee;
}

.btn-cancel:hover {
    background-color: #e0e0e0;
}

.btn-confirm {
    background-color: #1aad19;
    color: white;
    text-align: center;
    text-decoration: none;
    display: inline-flex;
    justify-content: center;
    align-items: center;
}

.btn-confirm:hover {
    background-color: #179b16;
}

.loading-mask {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.5);
    z-index: 9999;
    display: flex;
    justify-content: center;
    align-items: center;
}

.loading-content {
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 20px;
    background: white;
    border-radius: 8px;
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);

    p {
        margin-top: 16px;
        font-size: 16px;
        color: #333;
    }
}

.loading-spinner {
    width: 40px;
    height: 40px;
    border: 4px solid #f3f3f3;
    border-top: 4px solid #409eff;
    border-radius: 50%;
    animation: spin 1s linear infinite;
}

@keyframes spin {
    0% {
        transform: rotate(0deg);
    }

    100% {
        transform: rotate(360deg);
    }
}

:deep(.el-tag) {
    margin-right: 10px;
    margin-bottom: 10px;
    cursor: pointer;
}
</style>